import React, { Component } from 'react';
import { Chart } from 'primereact/chart';

const optionsVerticalBarChart = {
  plugins: {
    legend: {
      display: false
    }
  },
  scales: {
    x: {
      ticks: {
        autoSkip: false,
        minRotation: 0,
        maxRotation: 90,
        font: {
          size: 11
        }
      }
    },
    y: {
      beginAtZero: true,
      ticks: {
        font: {
          size: 11
        }
      }
    }
  }
};

class VerticalBarChart extends Component {


    constructor(props) {
        super(props);

        this.state = {
            values: {},
        };
    }

    componentDidMount() {
        this.setState({
            values: JSON.parse(this.props.values),
        });
    }

    render() {

        return (
            <div>
                <Chart type="bar" data={this.state.values} options={optionsVerticalBarChart} />
            </div>
        )
    }
}

export default VerticalBarChart;